import { render, staticRenderFns } from "./SaleDetailSection.vue?vue&type=template&id=093d8a06"
import script from "./SaleDetailSection.vue?vue&type=script&lang=js"
export * from "./SaleDetailSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports